import Vue from 'vue'
import Vuex from 'vuex'
import endpoints from 'api/endpoints'
import api from 'api'
import defaultInventoryManagement from '@/assets/js/columns/defaultInventoryManagement'
import defaultSuspendedProducts from '@/assets/js/columns/defaultSuspendedProducts'
import iziToast from 'izitoast'

import user from './modules/user'
import replenishment from './modules/replenishment'
import orders from './modules/orders'
import product from './modules/product'
import shippingPolicyState from './modules/shipping-policy-state'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        replenishment,
        orders,
        product,
        shippingPolicyState
    },
    state: {
        showMobileMenu: false,
        inventoryManagementColumns: defaultInventoryManagement,
        suspendedColumns: defaultSuspendedProducts,
        loading: false,
        globalError: {
            type: 'error',
            title: 'Error',
            message: 'Something happened',
            position: 'topRight',
            timeout: 10000
        }
    },
    mutations: {
        SET_LOADING(state, value) {
            state.loading = value
        },
        SHOW_MOBILE_MENU_CHANGED(state, value) {
            state.showMobileMenu = value
        },
        UPDATE_INVENTORY_COLUMNS(state, payload) {
            state.inventoryManagementColumns = payload
        },
        UPDATE_SUSPENDED_COLUMNS(state, payload) {
            state.suspendedColumns = payload
        }
    },
    actions: {
        changeStylesSpecialPage({commit, state}, payload) {
            document.body.className = payload
            return true
        },
        globalAlertAction({state, commit}, payload) {
            iziToast[payload.type]({
                title: payload.title,
                message: payload.message ? payload.message : '',
                position: payload.position ? payload.position : 'topLeft',
                timeout: payload.timeout ? payload.timeout : 4000
            })
        },
        productsListAPI({state, dispatch}, params) {
            return api('GET', endpoints.products, null, params)
                .then(response => response)
                // .catch(dispatch('globalAlertAction', state.globalError))
        },
        getItems({state, dispatch}, payload) {
            return api('GET', payload.endpoint, null, payload.params)
                .then(response => response)
                // .catch(dispatch('globalAlertAction', state.globalError))
        },
        productActions({state, dispatch}, endpoint) {
            return api('POST', endpoint)
                .then(() => dispatch('globalAlertAction', {
                    type: 'success',
                    title: 'Done.',
                    message: 'Succeed added'
                }))
                .catch()
        },
        deleteProduct({dispatch}, id) {
            return api('DELETE', endpoints.singleProduct(id)).then()
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js